<template>
  <div class="login-form">
    <h2>Faça seu Login</h2>
    <form @submit.prevent="handleLogin">
      <div class="form-group">
        <label for="username">Nome de Usuário</label>
        <input type="text" id="username" v-model="username" placeholder="Nome de Usuário" required>
      </div>
      <div class="form-group">
        <label for="password">Senha:</label>
        <input
            :type="showPassword ? 'text' : 'password'"
            id="password"
            v-model="password"
            placeholder="Senha"
            required>
        <div class="icon-text">
          <button type="button" class="hide-password" @click="togglePassword">
            <img
                class="show-password"
                :src="showPassword ? require('@/assets/hide.png') : require('@/assets/view.png')"
                alt="Toggle Password Visibility">
          </button>
          <span id="textoSenha">{{ showPassword ? 'Ocultar Senha' : 'Mostrar Senha' }}</span>
        </div>
      </div>
      <button type="submit" class="login">Entrar</button>
      <div class="error-message" v-if="errorMessage">{{ errorMessage }}</div>
    </form>
  </div>
</template>

<script>

import authService from '../services/authService';

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      errorMessage: '',
      showPassword: false,
    };
  },
  methods: {
    async handleLogin() {
      try {
        await authService.login(this.username, this.password);
        this.$router.push('/homepage');
      } catch (error) {
        console.error('Erro ao fazer login:', error);
        if (error.response && error.response.data) {
          this.errorMessage = error.response.data.message;
        } else {
          this.errorMessage = 'Erro ao conectar ao servidor. Por favor, tente novamente.';
        }
      }
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    }
  }
};

</script>

<style scoped>

.login-form {
  width: 50vw;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 20px;
}

.login-form h2 {
  margin-bottom: 1rem;
}

.form-group {
  margin-bottom: 1rem;
  width: 100%;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
}

.form-group input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #CCC;
  border-radius: 4px;
}

.login {
  width: 100%;
  padding: 0.75rem;
  background-color: #007BFF;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
}

button:hover {
  background: #0056B3;
}

.error-message {
  color: red;
  margin-top: 1rem;
  text-align: center;
}

.show-password {
  width: 25px;
  margin-top: 0.5rem;
}

.hide-password {
  border: none;
  background: none;
  cursor: pointer;
}

.hide-password:hover {
  background: none;
}

span {
  margin-left: 0.5rem;
}

.icon-text {
  align-items: center;
  display: flex;
  margin-top: 0.5rem;
}


@media (max-width: 475px) {

  .login-form {
    width: 100%;
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .login-form h2 {
    font-size: 1.5rem;
  }

  .form-group input {
    padding: 0.75rem;
  }

  button {
    font-size: 1rem;
  }
}

@media (min-width: 769px) {
  .login-form {
    width: 30vw;
    padding: 2rem;
  }

  .login-form h2 {
    font-size: 2rem;
  }

  .form-group input {
    padding: 0.5rem;
  }

  button {
    font-size: 1rem;
  }
}


</style>